/**
 * Checks whether a string looks like a valid JWT (three Base64URL-encoded segments separated by dots).
 * Used to guard against sending garbage tokens (e.g. error messages) as Bearer tokens.
 */
export const isValidJwt = (token: string): boolean => {
  if (typeof token !== 'string') return false;
  const parts = token.split('.');
  return parts.length === 3 && parts.every((part) => part.length > 0 && /^[A-Za-z0-9_-]+={0,2}$/.test(part));
};
